"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntheticStorageV2Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SyntheticStorageV2Factory = /** @class */ (function (_super) {
    __extends(SyntheticStorageV2Factory, _super);
    function SyntheticStorageV2Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SyntheticStorageV2Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SyntheticStorageV2Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SyntheticStorageV2Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SyntheticStorageV2Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SyntheticStorageV2Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SyntheticStorageV2Factory;
}(contracts_1.ContractFactory));
exports.SyntheticStorageV2Factory = SyntheticStorageV2Factory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610248806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c806306fdde031461004657806354fd4d50146100c357806395d89b41146100cb575b600080fd5b61004e6100d3565b6040805160208082528351818301528351919283929083019185019080838360005b83811015610088578181015183820152602001610070565b50505050905090810190601f1680156100b55780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b61004e610160565b61004e6101bb565b60018054604080516020600284861615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156101585780601f1061012d57610100808354040283529160200191610158565b820191906000526020600020905b81548152906001019060200180831161013b57829003601f168201915b505050505081565b6003805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156101585780601f1061012d57610100808354040283529160200191610158565b6002805460408051602060018416156101000260001901909316849004601f810184900484028201840190925281815292918301828280156101585780601f1061012d5761010080835404028352916020019161015856fea265627a7a72315820940010e298887f4d3471f092a23ecc55cfd8d538ba3f2f6e74c20807e19c918464736f6c63430005100032";
